export default __webpack_public_path__ + "1ff80bd765fae31d686de9cb64bb5ec9.svg";